import usePortalNotificationsInHome from "./usePortalNotificationsInHome";

const HomeNotificationContainer: React.FC = () => {
  usePortalNotificationsInHome();
  return null;
};

export default HomeNotificationContainer;
